import { connect } from 'react-redux'
import ReviewHeader from 'components/review/ReviewHeader'
import { setSignUpModalIsOpen } from 'redux/actions'

const mapStateToProps = (state) => ({
  isLogged: state.user.isLogged
})

const mapDispatchToProps = dispatch => ({
  setSignUpModalIsOpen: isOpen => dispatch(setSignUpModalIsOpen(isOpen))
})

export default connect(mapStateToProps, mapDispatchToProps)(ReviewHeader)
